


const Bye = ()=>{
    return(
        <div className="bye">
            See ya!! 
        </div>
    )
    }
    
    export default Bye